import { cn } from "@/lib/utils";

export default function Logo({ className }: { className?: string }) {
  return (
    <svg
      className={cn("w-4 h-4", className)}
      width="193"
      height="217"
      viewBox="0 0 193 217"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M108.562 84.3889V0L0 132.611H84.4375V217L193 84.3889H108.562Z" fill="url(#paint0_linear_184_31)" />
      <defs>
        <linearGradient id="paint0_linear_184_31" x1="0" y1="0" x2="192.876" y2="217.11" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF3E9D" />
          <stop offset="1" stopColor="#FFBD4A" />
        </linearGradient>
      </defs>
    </svg>
  );
}
